import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  ParagraphText,
  Popover,
  StackLayout,
} from '@leagueplatform/genesis-core';

import * as CONSTANTS from '../../utils/constant';

export function PopOver(props: any) {
  const { title } = props;
  const [open, setOpen] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      componentRef.current &&
      !componentRef.current.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <StackLayout css={{ display: 'inline' }} data-testid="titleTolltip">
      <Popover.Root open={open}>
        <Popover.Trigger>
          <div
            ref={componentRef}
            style={{
              display: 'inline-block', // Important: Use inline-block or similar
            }}
          >
            <Button
              priority="tertiary"
              quiet
              size="small"
              icon="statusInformationCircle"
              hideLabel
              onMouseOver={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
              onClick={() => setOpen(true)}
              onKeyDown={() => setOpen(false)}
              css={{
                padding: '$none',
                marginLeft: '$half',
                position: 'relative',
                top: 4,
              }}
            >
              {title}
            </Button>
          </div>
        </Popover.Trigger>
        <Popover.Content
          align="start"
          side="bottom"
          showCloseButton={false}
          css={{
            zIndex: 999999999,
            display: 'block',
            borderRadius: '$none',
            boxShadow: 'none',
            border: '1px solid #66717A',
            maxWidth: 375,
            padding: '12px !important',
            top: '3px',
            position: 'relative',
            '.GDS-popover-content': {
              display: 'block',
              width: '600px',
            },
          }}
        >
          <StackLayout horizontalAlignment="center">
            <ParagraphText
              css={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '-0.176px',
                color: 'rgba(0, 0, 0, 0.80)',
              }}
            >
              {CONSTANTS.SECONDARY_EMAIL_TOOLTIP_CONTENT_1}
            </ParagraphText>
            <ParagraphText
              css={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '-0.176px',
                color: 'rgba(0, 0, 0, 0.80)',
              }}
            >
              {CONSTANTS.SECONDARY_EMAIL_TOOLTIP_CONTENT_2}
            </ParagraphText>
            <ParagraphText
              css={{
                fontSize: '16px',
                fontStyle: 'normal',
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '-0.176px',
                color: 'rgba(0, 0, 0, 0.80)',
              }}
            >
              {CONSTANTS.SECONDARY_EMAIL_TOOLTIP_CONTENT_3}
            </ParagraphText>
          </StackLayout>
        </Popover.Content>
      </Popover.Root>
    </StackLayout>
  );
}
